import { useArticle } from '@queries/useArticle';
import { useSlugs } from '@queries/useSlugs';

interface IUseArticleData {
  id: string;
  slug: string;
  isPreview: boolean;
  isEnabled: boolean;
}

export const useArticleData = ({ id, slug, isPreview, isEnabled }: IUseArticleData) => {
  const { data: articlePreviewData } = useArticle(String(id), isPreview, isEnabled);
  const { data: articleData } = useSlugs([String(slug)]);

  if (!isPreview) {
    const [{ article }] = articleData;
    return article;
  }

  return articlePreviewData;
};
